import { ContextType } from '../../../State/Game/IContext';
import BaseUISystem from '../BaseUISystem';
import { UIActions } from '../../../State/UI/UIActions';
import Game from '../../../Game';
import DateHelper from '../../../Utility/DateHelper';
import { PlayerActions } from '../../../State/Player/PlayerActions';
import UITextComponent from '../../../Component/UI/Text';
import { WorldActions } from '../../../State/World/WorldActions';
import Renderable from '../../../Component/Renderable';
import { GameActions } from '../../../State/Game/GameActions';
import { REQUIRED_GATE_FRIENDS_LENGTH } from '../../../State/World/WorldReducer';
import Sprite from '../../../Prototype/Sprite';
import { AUDIO_UI_BUTTON_CLOSE, AUDIO_UI_BUTTON_DEFAULT } from '../../Audio';
import GameObject from '../../../GameObject/GameObject';
import { GameObjectEvent } from '../../../GameObject/GameObjectEvent';
import UINineSliceComponent from '../../../Component/UI/NineSlice';
import LeaderboardHelper from '../LeaderboardHelper';
import SpriteComponent from '../../../Component/Render/Sprite';
import {
    applyBounceButtonAnimation,
    applyDefaultButtonAnimation,
} from '../UIHelper';
import BaseMenu from './BaseMenu';

const BTN_CLOSE = 'main_container/button_close';
const BTN_STARS_OPEN =
    'main_container/group_container/group_stars/group_stars_container/button_star_open';
const TEXT_NO_STARS =
    'main_container/group_container/group_stars/group_stars_container/text_no_stars';
const BTN_COINS_OPEN =
    'main_container/group_container/group_coins/group_coins_container/button_coin_open';
const TEXT_WORLD_UNLOCK_TIMER = 'main_container/text_worldUnlockTimer';
const TEXT_STAR_COUNT =
    'main_container/group_container/group_stars/group_stars_container/text_starCount';

const GROUP_STARS_CONTAINER =
    'main_container/group_container/group_stars/group_stars_container';
const GROUP_COINS_CONTAINER =
    'main_container/group_container/group_coins/group_coins_container';

const ONE_DAY = DateHelper.daysToMilliseconds(1);

export default class WorldUnlockMenuHandler extends BaseMenu {
    private gateTimerInterval: any;
    private requiredStars: number;

    constructor(uiSystem: BaseUISystem) {
        super('worldUnlockMenu', uiSystem);
    }

    protected onCreate(): void {
        this.updateGateTimerText();
        this.setGateTimerInterval();

        // Tint nine slice components.
        this.element
            .find(GROUP_STARS_CONTAINER)
            .getComponent(UINineSliceComponent).tint = 0xffbe82;
        this.element
            .find(GROUP_COINS_CONTAINER)
            .getComponent(UINineSliceComponent).tint = 0xffbe82;

        // Button close.
        const btnClose = this.element.find(BTN_CLOSE);
        btnClose.on(GameObjectEvent.SELECTED, () => {
            this.system.state.dispatch(UIActions.hidePopup(this.name));
        });
        applyDefaultButtonAnimation(btnClose, AUDIO_UI_BUTTON_CLOSE);

        const btnStarsOpen = this.element.find(BTN_STARS_OPEN);
        btnStarsOpen.on(GameObjectEvent.SELECTED, () => {
            this.system.state.dispatch(
                WorldActions.OPEN_GATE_STARS(this.requiredStars)
            );
        });
        applyDefaultButtonAnimation(btnStarsOpen, AUDIO_UI_BUTTON_DEFAULT);

        const btnCoinsOpen = this.element.find(BTN_COINS_OPEN);
        btnCoinsOpen.on(GameObjectEvent.SELECTED, () => {
            this.system.state.dispatch(WorldActions.OPEN_GATE_COINS());
        });
        applyDefaultButtonAnimation(btnCoinsOpen, AUDIO_UI_BUTTON_DEFAULT);
    }

    protected onDestroy(): void {
        Game.ticker.clearInterval(this.gateTimerInterval);
        this.gateTimerInterval = null;
    }

    protected onShow(params: any): void {
        const playerStars = Game.player.getTotalStars();
        this.requiredStars = params.requiredStars;

        const starsText = this.element.find(TEXT_STAR_COUNT);
        starsText.getComponent(UITextComponent).text =
            playerStars + '/' + this.requiredStars;

        const btnStarsOpen = this.element.find(BTN_STARS_OPEN);
        const txtNoStars = this.element.find(TEXT_NO_STARS);

        const hasSufficientStars = playerStars >= this.requiredStars;
        btnStarsOpen.getComponent(Renderable).visible = hasSufficientStars;
        txtNoStars.getComponent(Renderable).visible = !hasSufficientStars;
    }

    private setGateTimerInterval() {
        if (Game.state.getState().playerState.gateTimer === null) return;
        if (typeof this.gateTimerInterval === 'function') return;

        this.gateTimerInterval = Game.ticker.setInterval(
            this.onGateTimer.bind(this),
            1000
        );
    }

    private onGateTimer() {
        const currentGateTimerDate = Game.state.getState().playerState
            .gateTimer;
        if (currentGateTimerDate === null) {
            Game.ticker.clearInterval(this.gateTimerInterval);
            this.gateTimerInterval = null;
            return;
        }

        const now = DateHelper.now();
        const timeDiff =
            now.getTime() -
            DateHelper.getDateFromValue(currentGateTimerDate).getTime();

        if (timeDiff >= ONE_DAY) {
            Game.state.dispatch(PlayerActions.updateTimers());
        }

        this.updateGateTimerText();
    }

    private updateGateTimerText() {
        const gateTimerDate = Game.state.getState().playerState.gateTimer;

        const textGateTimer = this.element.find(TEXT_WORLD_UNLOCK_TIMER);
        const textGateTimerComponent = textGateTimer.getComponent(
            UITextComponent
        );

        if (gateTimerDate === null) {
            textGateTimerComponent.text = '';
            return;
        }

        textGateTimerComponent.text = DateHelper.timeTo(
            DateHelper.now(),
            DateHelper.getDateFromValue(
                DateHelper.getDateFromValue(gateTimerDate).getTime() + ONE_DAY
            ),
            'hh:mm:ss'
        );
    }
}
